// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';

import type { TestId } from '@trello/test-ids';

import type { IconSize } from '../src/components/Icon';
import { Icon } from '../src/components/Icon';

export interface GlyphProps {
  /**
   * A string that is applied as an aria attribute on the icon.
   */
  label?: string;
  /**
   * The color that the Icon should be rendered as.
   * @default token('color.icon', '#42526E')
   */
  color?: string;
  /**
   * The size to render the Icon size.
   * @default "medium"
   */
  size?: IconSize;
  /**
   * A string that gets placed as a data attribute (data-testid) onto the
   * Icon wrapper so that our
   * smoketest can properly target and test the component
   * @default undefined
   */
  testId?: TestId | string;
  // Escape hatches
  /**
   * ⚠️ DO NOT USE THIS PROP UNLESS YOU REALLY REALLY HAVE TO.
   *
   * Places a class name on the Icon (more specifically, the svg itself). This
   * is placed in addition to the classes already placed on the Icon. This is
   * placed directly onto the SVG via the glyph templates that are
   * generated by IconGlyph.template.js
   *
   * Please refrain from using this unless absolutely necessary.
   * @default undefined
   */
  dangerous_className?: string;
  /**
   * The switch for the icon to be centered in the dedicated space with padding around it.
   * Designed for cases when icon is not inline.
   */
  block?: boolean;
}

const VoteIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.0003 12V19C3.99379 19.2619 4.09386 19.5155 4.278 19.7036C4.46214 19.8916 4.71488 19.9985 4.97934 20H5.99875V11H4.97934C4.71488 11.0015 4.46214 11.1084 4.278 11.2964C4.09386 11.4845 3.99379 11.7381 4.0003 12ZM19.2814 11.04C18.7031 10.3648 17.8537 9.97663 16.96 9.979H14.3256C14.366 9.798 14.4064 9.619 14.4367 9.447C14.9514 6.513 14.4367 5.447 13.932 4.85301C13.4706 4.31076 12.7907 3.99849 12.0749 4.00001C10.5305 4.05274 9.26304 5.22781 9.10746 6.751C8.71382 8.59 8.65327 8.751 8.13851 9.476L7.37143 10.565C7.13702 10.9004 7.01037 11.2981 7.00807 11.706V17.979C7.00941 18.5108 7.2239 19.0202 7.60436 19.3953C7.98483 19.7704 8.50009 19.9803 9.03681 19.979H16.2837C17.769 19.9868 19.0398 18.924 19.2814 17.472L19.9577 13.472C20.1065 12.6021 19.8589 11.7116 19.2814 11.04ZM17.283 17.14C17.2014 17.6233 16.7783 17.9768 16.2837 17.975L9.03681 17.975V11.706L9.80389 10.617C10.5253 9.57261 10.9727 8.36664 11.1059 7.108C11.1423 6.56547 11.3607 5.89944 12.0749 6C12.7891 6.10057 12.6502 7.916 12.4382 9.1C12.2229 10.081 11.9327 11.0445 11.5702 11.982L16.96 11.974C17.2574 11.9729 17.5402 12.1019 17.7328 12.3264C17.9255 12.551 18.0083 12.8483 17.9592 13.139L17.283 17.14Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const VoteIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  return (
    <Icon
      testId={testId || 'VoteIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={VoteIconGlyph}
    />
  );
};
